var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{attrs:{"id":"picture-tag"}},[_vm._l((_vm.sizeConfig),function(size){return (_vm.imageName)?_c('source',{attrs:{"media":`(min-width: ${size.minWidth}px)`,"srcset":_vm.getImageSrcset(size.maxWidth)}}):_vm._e()}),_c('img',{attrs:{"src":_vm.imageFallbackSrc.classic,"srcset":`${_vm.imageFallbackSrc.retina} 2x`,"alt":"Csepel photo"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }